import Box from "@/common/components/Box";
import Button from "@/common/components/Button";
import Checkbox from "@/common/components/Checkbox";
import { ErrorMessageWrapper } from "@/common/components/ErrorMessageWrapper";
import GoBackButton from "@/common/components/GoBackButton";
import TextArea from "@/common/components/TextArea";
import TextField from "@/common/components/TextField";
import { formatDateInLocalTimezone } from "@/common/utils/formatters";
import { ChevronsRight } from "lucide-react";
import { Link, useParams } from "react-router-dom";
import useHoliday from "../../hooks/useHoliday";
import { geoIdentifyTypeByObject } from "@/common/utils/geoUtils";
import { GeoData } from "@/common/types/geoGeoable";
import { GeoTransformers } from "@/common/services/geoTransformers";

export default function Show() {
  const { id } = useParams();

  const {
    data: initialHoliday,
    isPending: initialHolidayIsPending,
    error: initialHolidayError = {} as any,
    refetch: refetchHoliday,
  } = useHoliday(id || '');

  const disableUpdateButton = initialHolidayIsPending || initialHolidayError?.status === 403;

  return (
    <div>
      <div className="flex justify-between items-center mb-6">
        <div className="flex gap-2 items-center">
          <GoBackButton fallback="/holidays" searchLastRouteFromFallback />

          <p className="text-white-400 font-normal">
            Feriados
          </p>

          <ChevronsRight color='#ffffffb3' />

          <h2>
            {initialHoliday?.display_name}
          </h2>
        </div>

        <Link
          to={disableUpdateButton ? '' : `/holidays/${id}/edit`}
          className={disableUpdateButton ? "cursor-default" : ''}
        >
          <Button operationKlassToCheckPermission="Admin::Calendar::Holidays::Update" data-testid='update_holiday_button' type="submit" className="shadow-[4px_4px_8px_4px_rgba(0,_0,_0,_0.2)]" disabled={disableUpdateButton}>
            Editar
          </Button>
        </Link>
      </div>

      {initialHolidayIsPending ? (
        <Box>Carregando...</Box>
      ) : (
        <ErrorMessageWrapper
          className="max-h-[calc(100vh-128px)]"
          statusCode={initialHolidayError?.status}
          refetchFunction={refetchHoliday}
        >
          <Box className="flex flex-col gap-4 shadow-[4px_4px_8px_4px_rgba(0,_0,_0,_0.2)]">
            <p className="text-lg font-bold">
              {initialHoliday?.display_name}
            </p>

            <div className="flex gap-2">
              <TextField
                label="Nome do feriado"
                className="w-full"
                name="display_name"
                value={initialHoliday?.display_name}
                disabled
              />
              <TextField
                label="Data"
                name="date"
                className="w-full"
                value={formatDateInLocalTimezone(initialHoliday?.date ?? '')}
                disabled
              />
            </div>

            <TextArea
              label="Descrição"
              name="description"
              value={initialHoliday?.description}
              disabled
            />

            <Checkbox
              label="Bloquear adiantamento de fatura para essa data"
              checked={initialHoliday?.blocks_establishment_payment_advances}
              name="blocks_establishment_payment_advances"
              disabled
            />

            <TextField
              label="Aplicável na região"
              className="w-full"
              name="geo"
              value={GeoTransformers.geoLabelTransformer({
                geo: initialHoliday?.geo,
                geo_type: geoIdentifyTypeByObject(initialHoliday?.geo as GeoData)
              })}
              disabled
            />
          </Box>
        </ErrorMessageWrapper>
      )}

    </div>
  )
}
